export default '/(registered-session|live-session|sessions|session|recipe|tips|genealogyreveal|traditions|languagevideo|virtualtour|yourhometown|fashionshow|howtodance)/:id'
